import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function HandsSvg({ classNameProps, height, width }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='502'
      height='200'
      viewBox='0 0 502 200'
      fill='none'
    >
      <g opacity='0.4'>
        <path
          d='M6.92987 90.2762C6.92987 61.5751 22.2497 26.3673 33.3475 19.1323C40.4598 14.4959 48.3066 18.8321 49.7156 25.7897L49.8288 25.821C50.4723 25.2217 51.0886 24.6707 51.6659 24.1613C58.1193 18.4672 94.4863 13.2463 99.9438 22.0623L99.8652 22.1257C113.681 19.7678 129.027 19.5749 135.218 25.1108C137.292 26.9639 138.621 29.4945 139.194 32.3579C145.371 30.2538 151.325 28.6859 156.477 27.3292C160.083 26.3795 163.296 25.5333 165.918 24.6791C182.203 19.3735 191.129 52.5338 156.992 65.0744C138.158 71.9934 125.266 80.9913 118.752 104.626C117.659 108.592 116.36 111.94 115.327 114.602C113.918 118.235 113.004 120.592 113.782 121.504C115.219 123.187 122.43 119.94 142.958 110.698C143.602 110.408 144.259 110.112 144.929 109.811C165.556 100.526 177.137 110.172 174.483 123.195C171.269 138.966 142.005 144.989 128.2 147.831C124.364 148.62 121.722 149.164 121.165 149.603C111.515 157.2 87.7509 175.649 51.683 169.62C8.68865 162.433 6.92987 122.834 6.92987 90.2762Z'
          fill='white'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinejoin='round'
        />
        <path
          d='M19.4603 151.363C18.6654 152.836 18.1828 154.839 18.3896 157.561C19.1134 167.087 33.2269 181.678 65.1934 175.89C69.0261 175.196 73.3027 172.699 76.8544 170.157'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M60.2477 76.168C60.3684 53.4984 65.9394 33.8169 78.9535 27.9396C91.9675 22.0623 125.311 16.253 135.218 25.1108C137.292 26.9641 138.621 29.4952 139.194 32.359'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M34.9157 74.6003C31.4175 43.1282 44.5292 30.4584 51.666 24.1613C58.1193 18.4672 94.4863 13.2463 99.9438 22.0623'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M91.8523 80.509C99.6328 36.3154 147.45 30.6962 165.918 24.6791C182.203 19.3735 191.129 52.5338 156.992 65.0744C138.158 71.9934 125.266 80.9913 118.752 104.626C113.325 124.314 102.837 128.758 144.929 109.811C165.556 100.526 177.137 110.172 174.483 123.195C170.377 143.348 123.728 147.584 121.165 149.603C111.515 157.2 87.7509 175.649 51.683 169.62C8.68866 162.433 6.92989 122.834 6.92989 90.2762'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.92988 90.2762C6.92988 61.5751 22.2497 26.3673 33.3475 19.1323C40.4598 14.4959 48.3066 18.8321 49.7156 25.7897'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <g opacity='0.4'>
        <path
          d='M482.363 90.2762C482.363 61.5751 467.044 26.3673 455.946 19.1323C448.834 14.4959 440.987 18.8321 439.578 25.7897L439.465 25.821C438.821 25.2217 438.205 24.6707 437.627 24.1613C431.174 18.4672 394.807 13.2463 389.35 22.0623L389.428 22.1257C375.612 19.7678 360.267 19.5749 354.075 25.1108C352.002 26.9639 350.672 29.4945 350.099 32.3579C343.922 30.2538 337.968 28.6859 332.817 27.3292C329.21 26.3795 325.997 25.5333 323.375 24.6791C307.09 19.3735 298.164 52.5338 332.302 65.0744C351.135 71.9934 364.027 80.9913 370.541 104.626C371.634 108.592 372.933 111.94 373.966 114.602C375.375 118.235 376.29 120.592 375.511 121.504C374.074 123.187 366.863 119.94 346.335 110.698C345.691 110.408 345.035 110.112 344.364 109.811C323.737 100.526 312.157 110.172 314.811 123.195C318.024 138.966 347.289 144.989 361.093 147.831C364.929 148.62 367.571 149.164 368.128 149.603C377.779 157.2 401.542 175.649 437.61 169.62C480.605 162.433 482.363 122.834 482.363 90.2762Z'
          fill='white'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinejoin='round'
        />
        <path
          d='M469.833 151.363C470.628 152.836 471.11 154.839 470.904 157.561C470.18 167.087 456.066 181.678 424.1 175.89C420.267 175.196 415.991 172.699 412.439 170.157'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M429.046 76.168C428.925 53.4984 423.354 33.8169 410.34 27.9396C397.326 22.0623 363.982 16.253 354.075 25.1108C352.001 26.9641 350.672 29.4952 350.099 32.359'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M454.378 74.6003C457.876 43.1282 444.764 30.4584 437.627 24.1613C431.174 18.4672 394.807 13.2463 389.349 22.0623'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M397.441 80.509C389.66 36.3154 341.843 30.6962 323.375 24.6791C307.09 19.3735 298.164 52.5338 332.302 65.0744C351.135 71.9934 364.027 80.9913 370.541 104.626C375.968 124.314 386.457 128.758 344.364 109.811C323.737 100.526 312.157 110.172 314.811 123.195C318.917 143.348 365.565 147.584 368.128 149.603C377.779 157.2 401.542 175.649 437.61 169.62C480.605 162.433 482.363 122.834 482.363 90.2762'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M482.363 90.2762C482.363 61.5751 467.044 26.3673 455.946 19.1323C448.834 14.4959 440.987 18.8321 439.578 25.7897'
          stroke='#9FACB3'
          strokeWidth='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  );
}

export default HandsSvg;
